export default __webpack_public_path__ + "static/media/bar-code.d409ee8d.png";